class ProductReviewsIOFit extends HTMLElement {
    constructor() {
        super();
        this.sku = this.getAttribute('sku');
        this.maxRetries = 2;
    }

    connectedCallback() {
        this.fetchReviews();
    }

    returnEmptyReview() {
        // 5 stars empty with a disabled class and a (0)
        this.innerHTML = `<div class="product-reviews-io__stars">
            <div class="product-reviews-io__stars-container">
                <div class="product-reviews-io__stars-empty disabled">
                    ${this.getStarsSVG()}
                </div>
                <div class="product-reviews-io__stars-filled disabled" style="width: 100%;">
                    ${this.getStarsSVG()}
                </div>
            </div>
            <span class="product-reviews-io__stars-count">(0)</span>${this.link ? `<a href="#ReviewsWidget"></a>` : ''}
        </div>`;
    }

    retryFetch(attempt) {
        if (attempt >= this.maxRetries) {
            this.innerHTML = '';
            return;
        }

        window.setTimeout(() => {
            this.fetchReviews(attempt + 1);
        }, 250 * (attempt + 1));
    }

    fetchReviews(attempt = 0) {
        if (!this.sku) {
            return;
        }

        fetch(`https://api.reviews.io/reviews?store=teveo.com&sku=${this.sku}&type=product_review&include_subrating_breakdown=true&per_page=1`)
            .then(response => response.json())
            .then(data => {
                if (!data.stats || !data.stats.attributes) {
                    this.retryFetch(attempt);
                    return;
                }
                // a number from 1 to 5
                const fitAttribute = data.stats.attributes.find(attribute => attribute.id === 9410)

                if (!fitAttribute) {
                    this.retryFetch(attempt);
                    return;
                }
                const fitScore = fitAttribute.average_rating;

                if (!fitScore) {
                    this.retryFetch(attempt);
                    return;
                }

                const floatFitScore = parseFloat(fitScore);

                if (!floatFitScore) {
                    this.retryFetch(attempt);
                    return;
                }
                const left = floatFitScore * 100 / 5;

                const smallLabel = (typeof sizeIndicatorStrings !== 'undefined' && sizeIndicatorStrings.small) ? sizeIndicatorStrings.small : 'Small';
                const trueLabel = (typeof sizeIndicatorStrings !== 'undefined' && sizeIndicatorStrings.true) ? sizeIndicatorStrings.true : 'True to size';
                const bigLabel = (typeof sizeIndicatorStrings !== 'undefined' && sizeIndicatorStrings.big) ? sizeIndicatorStrings.big : 'Big';

                this.innerHTML = `<div class="product-sizing-slider__wrapper">
                  <div class="product-sizing-slider__background">
                    <div class="product-sizing-slider__track">
                      <div class="product-sizing-slider__thumb" style="left: ${left}%;"></div>
                    </div>
                  </div>
                  <div class="product-sizing-slider__labels">
                    <div class="product-sizing-slider__label">
                      <span>${smallLabel}</span>
                    </div>
                    <div class="product-sizing-slider__label">
                      <span>${trueLabel}</span>
                    </div>
                    <div class="product-sizing-slider__label">
                      <span>${bigLabel}</span>
                    </div>
                  </div>
             
                </div>`;
            })
            .catch(() => {
                this.retryFetch(attempt);
            });

    };
}


customElements.define('product-reviews-io-fit', ProductReviewsIOFit);

class ProductReviewsIOStars extends HTMLElement {
    constructor() {
        super();
        this.sku = this.getAttribute('sku');
        this.link = this.getAttribute('link');
    }

    connectedCallback() {
        this.fetchReviews();
    }

    returnEmptyReview() {
        // 5 stars had to be empty of stars to keep being a placeholder, but was asked to be removed
        this.remove();
        

        // this.innerHTML = `<div class="product-reviews-io__stars no-reviews">
        //     <div class="product-reviews-io__stars-container">
        //         <div class="product-reviews-io__stars-empty ">
        //             ${this.getStarsSVG()}
        //         </div>
      
        //     </div>
        //     <span class="product-reviews-io__stars-count">(0)</span>${this.link ? `<a href="#ReviewsWidget"></a>` : ''}
        // </div>`;
    }

    fetchReviews() {
        if (!this.sku) {
            this.returnEmptyReview();
            return;
        }

        fetch(`https://api.reviews.io/reviews?store=teveo.com&sku=${this.sku}&type=product_review&include_subrating_breakdown=false&per_page=1`)
            .then(response => response.json())
            .then(data => {
                if (!data.review_count || data.review_count === 0) {
                    this.returnEmptyReview();
                    return;
                }

                const rating = parseFloat(data.average_rating) || 0;
                const reviewCount = data.review_count || 0;
                const fillPercentage = (rating / 5) * 100;

                this.innerHTML = `<div class="product-reviews-io__stars">
                    <div class="product-reviews-io__stars-container">
                        <div class="product-reviews-io__stars-empty">
                            ${this.getStarsSVG()}
                        </div>
                        <div class="product-reviews-io__stars-filled" style="width: ${fillPercentage}%;">
                            ${this.getStarsSVG()}
                        </div>
                    </div>
                    
                        <span class="product-reviews-io__stars-count">(${reviewCount})</span>${this.link ? `<a href="${this.link}"></a>` : ''}
                </div>`;
            });
    };

    getStarsSVG() {
        const starSVG = `<svg class="product-reviews-io__star" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>`;
        return starSVG.repeat(5);
    }
}

customElements.define('product-reviews-io-stars', ProductReviewsIOStars);
